"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Button_1 = require("../components/common/v2/Button");
const continueSecondaryImg = require("../images/v2/continue.svg");
const continuePrimaryImg = require("../images/v2/continue_primary.svg");
const downloadPrimaryImg = require("../images/v2/download_primary.svg");
const downloadSecondaryImg = require("../images/v2/download_secondary.svg");
const edgeLogoImg = require("../images/v2/logo_edge.svg");
const newEdgeLogoImg = require("../images/v2/logo_edge_new.svg");
const teamsLogoImg = require("../images/v2/logo_teams.svg");
const reloadImg = require("../images/v2/reload.svg");
var ButtonKey;
(function (ButtonKey) {
    ButtonKey[ButtonKey["PrimaryContinueInThisBrowser"] = 0] = "PrimaryContinueInThisBrowser";
    ButtonKey[ButtonKey["PrimaryJoinInSupportedBrowser"] = 1] = "PrimaryJoinInSupportedBrowser";
    ButtonKey[ButtonKey["PrimaryJoinInSupportedBrowserNewEdge"] = 2] = "PrimaryJoinInSupportedBrowserNewEdge";
    ButtonKey[ButtonKey["PrimaryJoinInApp"] = 3] = "PrimaryJoinInApp";
    ButtonKey[ButtonKey["PrimaryJoinInAppUnsure"] = 4] = "PrimaryJoinInAppUnsure";
    ButtonKey[ButtonKey["PrimaryJoinInAppTfwUnsure"] = 5] = "PrimaryJoinInAppTfwUnsure";
    ButtonKey[ButtonKey["PrimaryJoinInAppUnsureNoMeetingText"] = 6] = "PrimaryJoinInAppUnsureNoMeetingText";
    ButtonKey[ButtonKey["PrimaryJoinInEdgeBrowser"] = 7] = "PrimaryJoinInEdgeBrowser";
    ButtonKey[ButtonKey["PrimaryJoinInNewEdgeBrowser"] = 8] = "PrimaryJoinInNewEdgeBrowser";
    ButtonKey[ButtonKey["PrimaryDownloadWindowsApp"] = 9] = "PrimaryDownloadWindowsApp";
    ButtonKey[ButtonKey["PrimaryDownloadWindowsTfwApp"] = 10] = "PrimaryDownloadWindowsTfwApp";
    ButtonKey[ButtonKey["PrimaryDownloadMacApp"] = 11] = "PrimaryDownloadMacApp";
    ButtonKey[ButtonKey["PrimaryDownloadLinuxApp"] = 12] = "PrimaryDownloadLinuxApp";
    ButtonKey[ButtonKey["SecondaryDownloadAgain"] = 13] = "SecondaryDownloadAgain";
    ButtonKey[ButtonKey["SecondaryJoinInApp"] = 14] = "SecondaryJoinInApp";
    ButtonKey[ButtonKey["SecondaryContinueInThisBrowser"] = 15] = "SecondaryContinueInThisBrowser";
})(ButtonKey = exports.ButtonKey || (exports.ButtonKey = {}));
var ButtonType;
(function (ButtonType) {
    ButtonType[ButtonType["Primary"] = 0] = "Primary";
    ButtonType[ButtonType["Secondary"] = 1] = "Secondary";
})(ButtonType = exports.ButtonType || (exports.ButtonType = {}));
class ButtonsFactory {
    constructor(flags, handlers) {
        this.flags = flags;
        this.handlers = handlers;
    }
    /* START: Helper methods to return right set of buttons */
    getEdgeSuccessButtons() {
        return [
            ...(this.flags.showDesktopButtons ? [this.getButton(ButtonKey.PrimaryJoinInApp)] : []),
            ...(this.flags.showDesktopButtons && !this.flags.hideDownloadButton ? [this.getButton(ButtonKey.PrimaryDownloadWindowsApp)] : []),
            this.getButton(ButtonKey.PrimaryJoinInEdgeBrowser),
        ];
    }
    getEdgeFailureButtons() {
        return [
            ...(this.flags.showDesktopButtons && !this.flags.hideDownloadButton ? [this.getButton(ButtonKey.PrimaryDownloadWindowsApp)] : []),
            this.getButton(ButtonKey.PrimaryJoinInEdgeBrowser),
            ...(this.flags.showDesktopButtons ? [this.getButton(ButtonKey.SecondaryJoinInApp)] : []),
        ];
    }
    getIE11SuccessButtons(pstnIsAvailable) {
        return [
            ...(this.flags.showDesktopButtons ? [this.getButton(ButtonKey.PrimaryJoinInApp)] : []),
            ...(this.flags.showDesktopButtons && !this.flags.hideDownloadButton ? [this.getButton(ButtonKey.PrimaryDownloadWindowsApp)] : []),
            this.getButton(ButtonKey.PrimaryJoinInNewEdgeBrowser),
            ...(pstnIsAvailable ? [this.getButton(ButtonKey.SecondaryContinueInThisBrowser)] : []),
        ];
    }
    getIE11FailureButtons(pstnIsAvailable) {
        return [
            ...(this.flags.showDesktopButtons && !this.flags.hideDownloadButton ? [this.getButton(ButtonKey.PrimaryDownloadWindowsApp)] : []),
            this.getButton(ButtonKey.PrimaryJoinInNewEdgeBrowser),
            ...(pstnIsAvailable ? [this.getButton(ButtonKey.SecondaryContinueInThisBrowser)] : []),
            ...(this.flags.showDesktopButtons ? [this.getButton(ButtonKey.SecondaryJoinInApp)] : []),
        ];
    }
    getIE11NoEdgeSuccessButtons(pstnIsAvailable) {
        return [
            ...(this.flags.showDesktopButtons ? [this.getButton(ButtonKey.PrimaryJoinInApp)] : []),
            ...(this.flags.showDesktopButtons && !this.flags.hideDownloadButton ? [this.getButton(ButtonKey.PrimaryDownloadWindowsApp)] : []),
            ...(pstnIsAvailable ? [this.getButton(ButtonKey.SecondaryContinueInThisBrowser)] : []),
        ];
    }
    getIE11NoEdgeFailureButtons(pstnIsAvailable) {
        return [
            ...(this.flags.showDesktopButtons && !this.flags.hideDownloadButton ? [this.getButton(ButtonKey.PrimaryDownloadWindowsApp)] : []),
            ...(pstnIsAvailable ? [this.getButton(ButtonKey.SecondaryContinueInThisBrowser)] : []),
            ...(this.flags.showDesktopButtons ? [this.getButton(ButtonKey.SecondaryJoinInApp)] : []),
        ];
    }
    getChromeLinuxButtons() {
        return [
            this.getButton(ButtonKey.PrimaryJoinInSupportedBrowser),
            ...(this.flags.showDesktopButtons ? [this.getButton(ButtonKey.PrimaryDownloadLinuxApp)] : []),
            ...(this.flags.showDesktopButtons ? [this.getButton(this.flags.meeting ? ButtonKey.PrimaryJoinInAppUnsure : ButtonKey.PrimaryJoinInAppUnsureNoMeetingText)] : []),
        ];
    }
    getChromeWindowsButtons(isEdgeAnaheim) {
        return [
            ...(this.flags.showDesktopButtons && !this.flags.hideDownloadButton ? [
                this.flags.isWindowsTfwUI ? this.getButton(ButtonKey.PrimaryDownloadWindowsTfwApp) : this.getButton(ButtonKey.PrimaryDownloadWindowsApp)
            ] : []),
            this.getButton(isEdgeAnaheim ? ButtonKey.PrimaryJoinInSupportedBrowserNewEdge : ButtonKey.PrimaryJoinInSupportedBrowser),
            ...(this.flags.showDesktopButtons ? [this.flags.isWindowsTfwUI ? this.getButton(ButtonKey.PrimaryJoinInAppTfwUnsure) :
                    this.getButton(this.flags.meeting ? ButtonKey.PrimaryJoinInAppUnsure : ButtonKey.PrimaryJoinInAppUnsureNoMeetingText)] : []),
        ];
    }
    getChromeMacOsButtons(isEdgeAnaheim) {
        return [
            ...(this.flags.showDesktopButtons ? [this.getButton(ButtonKey.PrimaryDownloadMacApp)] : []),
            this.getButton(isEdgeAnaheim ? ButtonKey.PrimaryJoinInSupportedBrowserNewEdge : ButtonKey.PrimaryJoinInSupportedBrowser),
            ...(this.flags.showDesktopButtons ? [this.getButton(this.flags.meeting ? ButtonKey.PrimaryJoinInAppUnsure : ButtonKey.PrimaryJoinInAppUnsureNoMeetingText)] : []),
        ];
    }
    getChromeUnsupportedOsButtons(isEdgeAnaheim) {
        return [
            this.getButton(isEdgeAnaheim ? ButtonKey.PrimaryJoinInSupportedBrowserNewEdge : ButtonKey.PrimaryJoinInSupportedBrowser),
        ];
    }
    getSafariMacOsButtons() {
        return [
            ...(this.flags.showDesktopButtons ? [this.getButton(ButtonKey.PrimaryDownloadMacApp)] : []),
            this.getButton(ButtonKey.PrimaryJoinInSupportedBrowser),
            ...(this.flags.showDesktopButtons ? [this.getButton(this.flags.meeting ? ButtonKey.PrimaryJoinInAppUnsure : ButtonKey.PrimaryJoinInAppUnsureNoMeetingText)] : []),
        ];
    }
    getUnsupportedOsButtons() {
        return [
            this.getButton(ButtonKey.SecondaryContinueInThisBrowser),
        ];
    }
    getOtherBrowsersWindowsButtons(pstnIsAvailable, isWindows10) {
        return [
            ...(this.flags.showDesktopButtons && !this.flags.hideDownloadButton ? [this.getButton(ButtonKey.PrimaryDownloadWindowsApp)] : []),
            ...(isWindows10 ? [this.getButton(ButtonKey.PrimaryJoinInNewEdgeBrowser)] : []),
            ...(pstnIsAvailable ? [this.getButton(ButtonKey.SecondaryContinueInThisBrowser)] : []),
            ...(this.flags.showDesktopButtons ? [this.getButton(ButtonKey.SecondaryJoinInApp)] : []),
        ];
    }
    getOtherBrowsersMacOsButtons(pstnIsAvailable) {
        return [
            ...(this.flags.showDesktopButtons ? [this.getButton(ButtonKey.PrimaryDownloadMacApp)] : []),
            ...(pstnIsAvailable ? [this.getButton(ButtonKey.SecondaryContinueInThisBrowser)] : []),
            ...(this.flags.showDesktopButtons ? [this.getButton(ButtonKey.SecondaryJoinInApp)] : []),
        ];
    }
    getOtherBrowsersLinuxButtons(pstnIsAvailable) {
        return [
            ...(this.flags.showDesktopButtons ? [this.getButton(ButtonKey.PrimaryDownloadLinuxApp)] : []),
            ...(pstnIsAvailable ? [this.getButton(ButtonKey.SecondaryContinueInThisBrowser)] : []),
            ...(this.flags.showDesktopButtons ? [this.getButton(ButtonKey.SecondaryJoinInApp)] : []),
        ];
    }
    /* END: Helper methods to return right set of buttons */
    getButton(key) {
        switch (key) {
            case ButtonKey.PrimaryJoinInApp:
                return (React.createElement(Button_1.Button, { key: ButtonKey.PrimaryJoinInApp, title: "btn_join_in_app_title", text: "btn_join_in_app_text", "data-tid": "joinInApp", type: ButtonType.Primary, iconSrc: teamsLogoImg, isAnimated: false, onClick: this.handlers.joinInApp }));
            case ButtonKey.PrimaryJoinInAppUnsure:
                return (React.createElement(Button_1.Button, { key: ButtonKey.PrimaryJoinInAppUnsure, title: "btn_join_in_app_unsure_title", text: "btn_join_in_app_unsure_text", "data-tid": "joinInApp", type: ButtonType.Primary, iconSrc: teamsLogoImg, isAnimated: false, onClick: this.handlers.joinInApp }));
            case ButtonKey.PrimaryJoinInAppUnsureNoMeetingText:
                return (React.createElement(Button_1.Button, { key: ButtonKey.PrimaryJoinInAppUnsureNoMeetingText, title: "btn_join_in_app_unsure_title", text: "btn_join_in_app_unsure_text_freemium_onboarding", "data-tid": "joinInApp", type: ButtonType.Primary, iconSrc: teamsLogoImg, isAnimated: false, onClick: this.handlers.joinInApp }));
            case ButtonKey.PrimaryJoinInEdgeBrowser:
                return (React.createElement(Button_1.Button, { key: ButtonKey.PrimaryJoinInEdgeBrowser, title: "btn_continue_on_browser_title", text: "btn_continue_on_browser_text", "data-tid": "joinOnWeb", type: ButtonType.Primary, iconSrc: edgeLogoImg, isAnimated: false, onClick: this.handlers.joinOnWeb }));
            case ButtonKey.PrimaryJoinInSupportedBrowser:
                return (React.createElement(Button_1.Button, { key: ButtonKey.PrimaryJoinInSupportedBrowser, title: "btn_continue_on_browser_title", text: "btn_continue_on_browser_text", "data-tid": "joinOnWeb", type: ButtonType.Primary, iconSrc: continuePrimaryImg, isAnimated: false, onClick: this.handlers.joinOnWeb }));
            case ButtonKey.PrimaryJoinInSupportedBrowserNewEdge:
                return (React.createElement(Button_1.Button, { key: ButtonKey.PrimaryJoinInSupportedBrowserNewEdge, title: "btn_continue_on_browser_title", text: "btn_continue_on_browser_text", "data-tid": "joinOnWeb", type: ButtonType.Primary, iconSrc: newEdgeLogoImg, isAnimated: false, onClick: this.handlers.joinOnWeb }));
            case ButtonKey.SecondaryDownloadAgain:
                return (React.createElement(Button_1.Button, { key: ButtonKey.SecondaryDownloadAgain, title: "btn_download_again_title", text: "btn_download_again_text", "data-tid": "download", type: ButtonType.Secondary, iconSrc: downloadSecondaryImg, isAnimated: false, onClick: this.handlers.download }));
            case ButtonKey.PrimaryDownloadWindowsTfwApp:
                return (React.createElement(Button_1.Button, { key: ButtonKey.PrimaryDownloadWindowsApp, title: "btn_download_windows_title_TFW", text: "btn_join_in_app_text", "data-tid": "download", type: ButtonType.Primary, iconSrc: downloadPrimaryImg, isAnimated: false, onClick: this.handlers.download }));
            case ButtonKey.PrimaryDownloadWindowsApp:
                return (React.createElement(Button_1.Button, { key: ButtonKey.PrimaryDownloadWindowsApp, title: "btn_download_windows_title", text: "btn_join_in_app_text", "data-tid": "download", type: ButtonType.Primary, iconSrc: downloadPrimaryImg, isAnimated: false, onClick: this.handlers.download }));
            case ButtonKey.PrimaryDownloadMacApp:
                return (React.createElement(Button_1.Button, { key: ButtonKey.PrimaryDownloadMacApp, title: "btn_download_mac_title", text: "btn_join_in_app_text", "data-tid": "download", type: ButtonType.Primary, iconSrc: downloadPrimaryImg, isAnimated: false, onClick: this.handlers.download }));
            case ButtonKey.PrimaryDownloadLinuxApp:
                return (React.createElement(Button_1.Button, { key: ButtonKey.PrimaryDownloadLinuxApp, title: "btn_download_linux_title", text: "btn_join_in_app_text", "data-tid": "download", type: ButtonType.Primary, iconSrc: downloadPrimaryImg, isAnimated: false, onClick: this.handlers.redirectToDownloadPage }));
            case ButtonKey.SecondaryJoinInApp:
                return (React.createElement(Button_1.Button, { key: ButtonKey.SecondaryJoinInApp, title: "btn_try_to_join_in_app_again_title", text: "btn_try_to_join_in_app_again_text", "data-tid": "joinInApp", type: ButtonType.Secondary, iconSrc: reloadImg, isAnimated: false, onClick: this.handlers.joinInApp }));
            case ButtonKey.PrimaryJoinInAppTfwUnsure:
                return (React.createElement(Button_1.Button, { key: ButtonKey.PrimaryJoinInAppTfwUnsure, title: "btn_join_in_app_unsure_windows_TFW", text: "btn_join_in_app_unsure_text", animatedText: "txt_coachmark_unsure_open_teams_hint", "data-tid": "joinInApp", type: ButtonType.Primary, iconSrc: teamsLogoImg, isAnimated: true, onClick: this.handlers.joinInApp }));
            case ButtonKey.PrimaryJoinInNewEdgeBrowser:
                return (React.createElement(Button_1.Button, { key: ButtonKey.PrimaryJoinInNewEdgeBrowser, title: "btn_use_new_edge_title", text: "btn_continue_on_browser_text", "data-tid": "joinInEdge", type: ButtonType.Primary, iconSrc: newEdgeLogoImg, isAnimated: false, onClick: this.handlers.redirectToEdge }));
            case ButtonKey.PrimaryContinueInThisBrowser:
                return (React.createElement(Button_1.Button, { key: ButtonKey.PrimaryContinueInThisBrowser, title: "btn_continue_on_browser_title", text: "btn_lmj_continue_in_browser_text", "data-tid": "joinOnWeb", type: ButtonType.Primary, iconSrc: continuePrimaryImg, isAnimated: false, onClick: this.handlers.joinOnWeb }));
            case ButtonKey.SecondaryContinueInThisBrowser:
                return (React.createElement(Button_1.Button, { key: ButtonKey.SecondaryContinueInThisBrowser, title: "btn_continue_on_browser_title", text: "btn_lmj_continue_in_browser_text", "data-tid": "joinOnWeb", type: ButtonType.Secondary, iconSrc: continueSecondaryImg, firstLineAsLink: true, isAnimated: false, onClick: this.handlers.joinOnWeb }));
            default:
                return (React.createElement("div", { className: "not_implemented" }));
        }
    }
}
exports.ButtonsFactory = ButtonsFactory;
